/* eslint-disable import/first */
window.Proxy = window.Proxy || function () {};

import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import "antd/dist/antd.css";

import "moment/locale/bs";
import Application from "./Application";
import "./ui/assets/scss/main.scss";

import { BaseConstants, BooleanToIntegerConstants } from "./common/Constants";

const rootElement = document.getElementById("app");

export function run(appName: string, context = "/") {
  if (rootElement) {
    const app = new Application(appName, context, rootElement);

    return app.start();
  }
}

export function parseBooleanValue(value: boolean) {
  return value ? BaseConstants.TRUE : BaseConstants.FALSE;
}
export function parseBooleanValueAsInteger(value: boolean) {
  return value
    ? BooleanToIntegerConstants.TRUE
    : BooleanToIntegerConstants.FALSE;
}

export function formatBooleanValue(value: string) {
  return value === BaseConstants.TRUE;
}
export function formatBooleanValueFromInteger(value: number) {
  return value === BooleanToIntegerConstants.TRUE;
}

if (typeof process.env.REACT_APP_APPLICATION_NAME === "string")
  run(process.env.REACT_APP_APPLICATION_NAME);
else throw new Error("You must define an application!");
